import { render, staticRenderFns } from "./ModalEbill.vue?vue&type=template&id=3b48837c&scoped=true&"
import script from "./ModalEbill.vue?vue&type=script&lang=js&"
export * from "./ModalEbill.vue?vue&type=script&lang=js&"
import style0 from "./ModalEbill.vue?vue&type=style&index=0&id=3b48837c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b48837c",
  null
  
)

export default component.exports